import { gql, useMutation } from '@apollo/client'

const mutation = gql`
  mutation createAnnouncement($groupId: String!, $title: String!, $body: String, $scheduledDate: String ) {
    createAnnouncement(groupId: $groupId, title: $title, body: $body, scheduledDate: $scheduledDate) {
      post {
        id
      }
    }
  }
`

export interface CreateAnnouncementInput {
  groupId: string
  title: string
  body?: string
  scheduledDate?: string
}

export interface CreateAnnouncementOutput {
  createAnnouncement: {
    post: {
      id: string
    }
  }
}

export const useCreateAnnouncement = () => useMutation<CreateAnnouncementOutput, CreateAnnouncementInput>(mutation)
